/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginCallbackRouteImport } from './routes/login-callback'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as VerifyEmailTokenRouteImport } from './routes/verify-email.$token'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password.$token'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedSubscriptionIndexRouteImport } from './routes/_authenticated/subscription/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedJobsIndexRouteImport } from './routes/_authenticated/jobs/index'
import { Route as AuthenticatedHelpIndexRouteImport } from './routes/_authenticated/help/index'
import { Route as AuthenticatedCandidatesIndexRouteImport } from './routes/_authenticated/candidates/index'
import { Route as AuthenticatedApplicationsIndexRouteImport } from './routes/_authenticated/applications/index'
import { Route as AuthenticatedJobsCreateRouteImport } from './routes/_authenticated/jobs/create'
import { Route as AuthenticatedJobsSlugRouteImport } from './routes/_authenticated/jobs/$slug'
import { Route as AuthenticatedCandidatesIdRouteImport } from './routes/_authenticated/candidates/$id'
import { Route as AuthenticatedApplicationsIdRouteImport } from './routes/_authenticated/applications/$id'
import { Route as AuthenticatedJobsIdEditRouteImport } from './routes/_authenticated/jobs/$id.edit'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginCallbackRoute = LoginCallbackRouteImport.update({
  id: '/login-callback',
  path: '/login-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const VerifyEmailTokenRoute = VerifyEmailTokenRouteImport.update({
  id: '/verify-email/$token',
  path: '/verify-email/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSubscriptionIndexRoute =
  AuthenticatedSubscriptionIndexRouteImport.update({
    id: '/subscription/',
    path: '/subscription/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsIndexRoute = AuthenticatedJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHelpIndexRoute = AuthenticatedHelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCandidatesIndexRoute =
  AuthenticatedCandidatesIndexRouteImport.update({
    id: '/candidates/',
    path: '/candidates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApplicationsIndexRoute =
  AuthenticatedApplicationsIndexRouteImport.update({
    id: '/applications/',
    path: '/applications/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsCreateRoute = AuthenticatedJobsCreateRouteImport.update({
  id: '/jobs/create',
  path: '/jobs/create',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedJobsSlugRoute = AuthenticatedJobsSlugRouteImport.update({
  id: '/jobs/$slug',
  path: '/jobs/$slug',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCandidatesIdRoute =
  AuthenticatedCandidatesIdRouteImport.update({
    id: '/candidates/$id',
    path: '/candidates/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApplicationsIdRoute =
  AuthenticatedApplicationsIdRouteImport.update({
    id: '/applications/$id',
    path: '/applications/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsIdEditRoute = AuthenticatedJobsIdEditRouteImport.update({
  id: '/jobs/$id/edit',
  path: '/jobs/$id/edit',
  getParentRoute: () => AuthenticatedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/login-callback': typeof LoginCallbackRoute
  '/register': typeof RegisterRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/verify-email/$token': typeof VerifyEmailTokenRoute
  '/applications/$id': typeof AuthenticatedApplicationsIdRoute
  '/candidates/$id': typeof AuthenticatedCandidatesIdRoute
  '/jobs/$slug': typeof AuthenticatedJobsSlugRoute
  '/jobs/create': typeof AuthenticatedJobsCreateRoute
  '/applications/': typeof AuthenticatedApplicationsIndexRoute
  '/candidates/': typeof AuthenticatedCandidatesIndexRoute
  '/help/': typeof AuthenticatedHelpIndexRoute
  '/jobs/': typeof AuthenticatedJobsIndexRoute
  '/profile/': typeof AuthenticatedProfileIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/subscription/': typeof AuthenticatedSubscriptionIndexRoute
  '/jobs/$id/edit': typeof AuthenticatedJobsIdEditRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/login-callback': typeof LoginCallbackRoute
  '/register': typeof RegisterRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/verify-email/$token': typeof VerifyEmailTokenRoute
  '/': typeof AuthenticatedIndexRoute
  '/applications/$id': typeof AuthenticatedApplicationsIdRoute
  '/candidates/$id': typeof AuthenticatedCandidatesIdRoute
  '/jobs/$slug': typeof AuthenticatedJobsSlugRoute
  '/jobs/create': typeof AuthenticatedJobsCreateRoute
  '/applications': typeof AuthenticatedApplicationsIndexRoute
  '/candidates': typeof AuthenticatedCandidatesIndexRoute
  '/help': typeof AuthenticatedHelpIndexRoute
  '/jobs': typeof AuthenticatedJobsIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/subscription': typeof AuthenticatedSubscriptionIndexRoute
  '/jobs/$id/edit': typeof AuthenticatedJobsIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/login-callback': typeof LoginCallbackRoute
  '/register': typeof RegisterRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/verify-email/$token': typeof VerifyEmailTokenRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/applications/$id': typeof AuthenticatedApplicationsIdRoute
  '/_authenticated/candidates/$id': typeof AuthenticatedCandidatesIdRoute
  '/_authenticated/jobs/$slug': typeof AuthenticatedJobsSlugRoute
  '/_authenticated/jobs/create': typeof AuthenticatedJobsCreateRoute
  '/_authenticated/applications/': typeof AuthenticatedApplicationsIndexRoute
  '/_authenticated/candidates/': typeof AuthenticatedCandidatesIndexRoute
  '/_authenticated/help/': typeof AuthenticatedHelpIndexRoute
  '/_authenticated/jobs/': typeof AuthenticatedJobsIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/subscription/': typeof AuthenticatedSubscriptionIndexRoute
  '/_authenticated/jobs/$id/edit': typeof AuthenticatedJobsIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/login-callback'
    | '/register'
    | '/notifications'
    | '/reset-password/$token'
    | '/verify-email/$token'
    | '/applications/$id'
    | '/candidates/$id'
    | '/jobs/$slug'
    | '/jobs/create'
    | '/applications/'
    | '/candidates/'
    | '/help/'
    | '/jobs/'
    | '/profile/'
    | '/settings/'
    | '/subscription/'
    | '/jobs/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/login-callback'
    | '/register'
    | '/notifications'
    | '/reset-password/$token'
    | '/verify-email/$token'
    | '/'
    | '/applications/$id'
    | '/candidates/$id'
    | '/jobs/$slug'
    | '/jobs/create'
    | '/applications'
    | '/candidates'
    | '/help'
    | '/jobs'
    | '/profile'
    | '/settings'
    | '/subscription'
    | '/jobs/$id/edit'
  id:
    | '__root__'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/login-callback'
    | '/register'
    | '/_authenticated/notifications'
    | '/reset-password/$token'
    | '/verify-email/$token'
    | '/_authenticated/'
    | '/_authenticated/applications/$id'
    | '/_authenticated/candidates/$id'
    | '/_authenticated/jobs/$slug'
    | '/_authenticated/jobs/create'
    | '/_authenticated/applications/'
    | '/_authenticated/candidates/'
    | '/_authenticated/help/'
    | '/_authenticated/jobs/'
    | '/_authenticated/profile/'
    | '/_authenticated/settings/'
    | '/_authenticated/subscription/'
    | '/_authenticated/jobs/$id/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  LoginCallbackRoute: typeof LoginCallbackRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
  VerifyEmailTokenRoute: typeof VerifyEmailTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-callback': {
      id: '/login-callback'
      path: '/login-callback'
      fullPath: '/login-callback'
      preLoaderRoute: typeof LoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/verify-email/$token': {
      id: '/verify-email/$token'
      path: '/verify-email/$token'
      fullPath: '/verify-email/$token'
      preLoaderRoute: typeof VerifyEmailTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/subscription/': {
      id: '/_authenticated/subscription/'
      path: '/subscription'
      fullPath: '/subscription/'
      preLoaderRoute: typeof AuthenticatedSubscriptionIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/': {
      id: '/_authenticated/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AuthenticatedJobsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/help/': {
      id: '/_authenticated/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof AuthenticatedHelpIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/candidates/': {
      id: '/_authenticated/candidates/'
      path: '/candidates'
      fullPath: '/candidates/'
      preLoaderRoute: typeof AuthenticatedCandidatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/applications/': {
      id: '/_authenticated/applications/'
      path: '/applications'
      fullPath: '/applications/'
      preLoaderRoute: typeof AuthenticatedApplicationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/create': {
      id: '/_authenticated/jobs/create'
      path: '/jobs/create'
      fullPath: '/jobs/create'
      preLoaderRoute: typeof AuthenticatedJobsCreateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/$slug': {
      id: '/_authenticated/jobs/$slug'
      path: '/jobs/$slug'
      fullPath: '/jobs/$slug'
      preLoaderRoute: typeof AuthenticatedJobsSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/candidates/$id': {
      id: '/_authenticated/candidates/$id'
      path: '/candidates/$id'
      fullPath: '/candidates/$id'
      preLoaderRoute: typeof AuthenticatedCandidatesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/applications/$id': {
      id: '/_authenticated/applications/$id'
      path: '/applications/$id'
      fullPath: '/applications/$id'
      preLoaderRoute: typeof AuthenticatedApplicationsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/$id/edit': {
      id: '/_authenticated/jobs/$id/edit'
      path: '/jobs/$id/edit'
      fullPath: '/jobs/$id/edit'
      preLoaderRoute: typeof AuthenticatedJobsIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedApplicationsIdRoute: typeof AuthenticatedApplicationsIdRoute
  AuthenticatedCandidatesIdRoute: typeof AuthenticatedCandidatesIdRoute
  AuthenticatedJobsSlugRoute: typeof AuthenticatedJobsSlugRoute
  AuthenticatedJobsCreateRoute: typeof AuthenticatedJobsCreateRoute
  AuthenticatedApplicationsIndexRoute: typeof AuthenticatedApplicationsIndexRoute
  AuthenticatedCandidatesIndexRoute: typeof AuthenticatedCandidatesIndexRoute
  AuthenticatedHelpIndexRoute: typeof AuthenticatedHelpIndexRoute
  AuthenticatedJobsIndexRoute: typeof AuthenticatedJobsIndexRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSubscriptionIndexRoute: typeof AuthenticatedSubscriptionIndexRoute
  AuthenticatedJobsIdEditRoute: typeof AuthenticatedJobsIdEditRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedApplicationsIdRoute: AuthenticatedApplicationsIdRoute,
  AuthenticatedCandidatesIdRoute: AuthenticatedCandidatesIdRoute,
  AuthenticatedJobsSlugRoute: AuthenticatedJobsSlugRoute,
  AuthenticatedJobsCreateRoute: AuthenticatedJobsCreateRoute,
  AuthenticatedApplicationsIndexRoute: AuthenticatedApplicationsIndexRoute,
  AuthenticatedCandidatesIndexRoute: AuthenticatedCandidatesIndexRoute,
  AuthenticatedHelpIndexRoute: AuthenticatedHelpIndexRoute,
  AuthenticatedJobsIndexRoute: AuthenticatedJobsIndexRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSubscriptionIndexRoute: AuthenticatedSubscriptionIndexRoute,
  AuthenticatedJobsIdEditRoute: AuthenticatedJobsIdEditRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  LoginCallbackRoute: LoginCallbackRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
  VerifyEmailTokenRoute: VerifyEmailTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
